/**
 * The one localStorage key the settings blob lives under.
 *
 * It sits in a file of its own because two modules must read it and one
 * of them may not import the other: `gen/strings.ts` picks the language
 * from the stored blob when it evaluates (R855), and `ui/settings.ts`
 * imports `net/api.ts`, which imports `gen/strings.ts`. A shared key in
 * `settings.ts` would close that ring.
 *
 * `ui/settings.ts` re-exports it, so every call site keeps its import.
 */
export const SETTINGS_KEY = 'aquaphobia.settings';
